import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnchorStyled, ImageStyled, TextStyled } from './image-link.styles';
/**
 * TODO: Description to be provided by component owner.
 */
export function ImageLink({ image, link, title, host, dataGa, }) {
    const baseUrl = host ? 'https://' + host : '';
    return (_jsxs(AnchorStyled, { href: baseUrl + link.href, ...(link.rel && { rel: link.rel }), title: title, "data-testid": "test-image-link", "data-ga": dataGa, children: [_jsx(ImageStyled, { src: image.src, alt: image.alt }), _jsx(TextStyled, { children: title })] }));
}
//# sourceMappingURL=image-link.js.map